import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import DriverAvatar from '@assets/driverAvatar.png';
import VehicleAvatar from '@assets/vehicleAvatar.png';
import Image from '@components/Image/Image';
import type { RootState } from '@store/store';

import classes from './DriverCard.module.scss';

export const DriverCard: React.FC = () => {
	const vehicleColor = useSelector((state: RootState) => state.trips.currentTrip?.vehicle?.color);
	const vehicleMake = useSelector((state: RootState) => state.trips.currentTrip?.vehicle?.make);
	const vehicleModel = useSelector((state: RootState) => state.trips.currentTrip?.vehicle?.model);
	const vehicleLicensePlate = useSelector((state: RootState) => state.trips.currentTrip?.vehicle?.licensePlate);
	const driverFirstName = useSelector((state: RootState) => state.trips.currentTrip?.driver?.firstName);
	const driverLastName = useSelector((state: RootState) => state.trips.currentTrip?.driver?.lastName);
	const driverCompany = useSelector((state: RootState) => state.trips.currentTrip?.driver?.company);

	const { t } = useTranslation();

	return (
		<div className={classes['container']}>
			<div className={classes['headerContainer']}>
				<p className={classes['headerText']}>{t('driverCard.driverDetails')}</p>
				<div className={classes['vehicleHeader']}>
					{vehicleMake && <p className={classes['vehicle']}>{vehicleMake}</p>}
					{vehicleModel && <p className={classes['vehicle']}>{vehicleModel}</p>}
					{vehicleColor && <p className={classes['vehicle']}>{vehicleColor}</p>}
				</div>
			</div>
			<div className={classes['infoContainer']}>
				<div className={classes['driverInfo']}>
					<Image src={DriverAvatar} name={t('tripCard.imgAlt')} size={50} />
					<div className={classes['driverTextContainer']}>
						<p className={classes['driverName']}>
							{driverFirstName} {driverLastName}
						</p>
						<p className={classes['driverCompany']}>{driverCompany}</p>
					</div>
				</div>
				<div className={classes['vehicleInfo']}>
					<Image src={VehicleAvatar} name={t('tripCard.imgAlt')} size={50} />
					<p className={classes['vehicleLicensePlate']}>{vehicleLicensePlate}</p>
				</div>
			</div>
		</div>
	);
};
